import React from "react";
import "./DelOverlay.css";

import CloseButton from "../../assets/close-icon.svg";

const DelOverlay = ({ deliciousData, isOpen, setIsOpen, overlayPosition }) => {
  return (
    <div className="delicious100-interactive__overlay">
      <div
        className="delicious100-interactive__overlay__background"
        onClick={() => setIsOpen(false)}
      />
      <div
        className="delicious100-interactive__overlay__container"
        style={{ top: `${overlayPosition}px` }}
      >
        <div className="delicious100-interactive__overlay__controls">
          <span className="delicious100-interactive__restaurant_name">
            {deliciousData?.["restaurant-name"]}
          </span>
          <img
            className="delicious100-interactive__overlay__close"
            src={CloseButton}
            alt="CloseButton"
            onClick={() => setIsOpen(false)}
          ></img>
        </div>
        <br></br>
        <div>
          <span className="delicious100-interactive__label">Address: </span>
          <br></br>
          {deliciousData &&
            deliciousData?.address &&
            deliciousData?.address?.map((addressVal, index) => (
              <div key={addressVal + " " + index}>
                <span className="delicious100-interactive__address">
                  {addressVal}
                </span>
                <br></br>
              </div>
            ))}
        </div>
        <br></br>
        <div>
          <span className="delicious100-interactive__label">Website: </span>
          <a
            className="delicious100-interactive__website"
            href={"https://" + deliciousData?.["website url"]}
          >
            {deliciousData?.["website url"]}
          </a>
        </div>
        <div>
          <span className="delicious100-interactive__label">Cuisine: </span>
          <span className="delicious100-interactive__cuisine">
            {deliciousData?.cuisine}
          </span>
        </div>
        {/* <div>
          <span className="delicious100-interactive__label">Region: </span>
          <span className="delicious100-interactive__region">
            {deliciousData?.region}
          </span>
        </div> */}

        <br></br>
        <span className="delicious100-interactive__review">
          {deliciousData?.["review-copy"]}
        </span>
        <br></br>
        <img
          className="delicious100-interactive__image"
          src={
            "https://d2n6ofw4o746cn.cloudfront.net/interactives/delicious100/sa/original_img/" +
            deliciousData?.["image-url"]
          }
          alt={deliciousData?.["image-url"]}
        ></img>
      </div>
    </div>
  );
};

export default DelOverlay;
